import * as React from "react";
import { CompanyWizardFilter } from "./CompanyWizardFilter";
import { Dictionary } from "../../../../../react-core/Helpers/CommonHelper";
import { CompanyStore } from "../Stores/Variable";
import { CompanyWizardAction } from "../Actions/CompanyWizardAction";
import { CancelFirmInstructionsQuery } from "../../../../../Wrap/Models/Models/Company/CancelFirmInstructionsQuery";
import { FormComponent } from "../../../../../react-core/Html/FormComponent";
import { SelectEditor } from "../../../../../react-core/Html/SelectEditor";
import { Navigator } from "../../../../Shared/Wizards/Entities/Navigator";
import { Urls } from "../../../../Dashboard/Urls";
import { FirmType } from "../../../../../Wrap/Constants/Enums/Domain/FirmType";
import { FirmTypeMap, FsaAuthorisationStatusMap } from "../Resource/Content";
import { Table } from "../../../../Shared/Table/Table";
import { CompanySummariesPaginated } from "../../../../../Wrap/Models/Models/Company/CompanySummariesPaginated";
import { CompanyDetailSort } from "../../../../../Wrap/Constants/Enums/Domain/CompanyDetailSort";
import { CompanySummary } from "../../../../../Wrap/Models/Models/Company/CompanySummary";
import { checkPermission } from "../../../../Shared/Permission/PermissionHelper";
import { UserClaim } from "../../../../../Wrap/Constants/Enums/UserClaim";
import { UserStore } from "../../../../Dashboard/Stroes/Variable";
import { UserClient } from "../../../../../Wrap/Api/User/User";
import { IndividualUserFunctionClient } from "../../../../../Wrap/Api/User/IndividualUserFunction";

interface ICompanySetUpState {
    tableData: CompanySummariesPaginated;
    isLoading?: boolean;
    currentPage: number;
    pageSize: number;
    filter: any;
    createType: string;
    firmType: FirmType;
    selectFirm: CompanySummary;
    SortDescending: boolean;
    OrderBy: CompanyDetailSort;
    hasCompanyPermission: boolean;
}

export class CompanySetUp extends FormComponent<null, ICompanySetUpState> {
    constructor(props: null) {
        super(props);
        this.state = {
            tableData: null,
            isLoading: false,
            currentPage: 1,
            pageSize: 10,
            createType: "Adviser",
            firmType: FirmType.AppointedRepresentative,
            selectFirm: null,
            SortDescending: true,
            OrderBy: CompanyDetailSort.DateCreated,
            filter: {
                firmID: null,
                processType: 0,
                firmType: 0,
                firmName: "",
                reference: "",
                postcode: "",
                createdBy: null,
                dateStartedFrom: null,
                dateStartedTo: null,
                lastUpdatedFrom: null,
                lastUpdatedTo: null,
                network: "",
            },
            hasCompanyPermission: false,
        };
        this.subscribeToStore(CompanyStore, () => this.onCompanyStoreChange());
    }

    componentDidMount() {
        const clientId = UserStore.getUserInfo().ClientId;

        if (clientId == null || clientId == 0) {
            const client = new UserClient();
            const promise = client.get();

            promise.onSuccess((result) => {
                this.checkCompanyPermission(result.ClientId);
            });
            promise.onError((err) => {});
        } else {
            this.checkCompanyPermission(clientId);
        }
    }

    public checkCompanyPermission(clientId: number) {
        const FunctionName = "CanModifyCompanies";
        const client = new IndividualUserFunctionClient();
        const promise = client.get(clientId, FunctionName);

        promise
            .onSuccess((data) => {
                this.setState({ hasCompanyPermission: data });
            })
            .onError(() => {
                this.setState({ hasCompanyPermission: false });
            });
    }

    public render(): JSX.Element {
        if (!checkPermission(UserClaim.AdviserPortalNetworkAndFirmReadWrite)) {return null;}
        return (
            <>
                {this.renderFilter()}
                <div className="row narrow-gutter">
                    <div className="col-12">OR</div>
                </div>
                <br />
                {this.renderSetup()}
                <hr />
                {!this.state.selectFirm && this.renderTable()}
                {this.state.selectFirm && this.renderSelectedFirm()}
            </>
        );
    }

    private renderSelectedFirm() {
        return (
            <div className="row">
                <div className="col-xs-6 col-sm-3">
                    <div className="form-group">
                        <h3 className="text-bold">Selected Firm</h3>
                        <div className="controls">{this.state.selectFirm.CompanyName}</div>
                    </div>
                </div>

                <div className="col-auto col-bottom">
                    <div className="form-group">
                        <button
                            className="btn secondary mr-10"
                            onClick={() => this.state.hasCompanyPermission && this.onClickEdit()}
                            disabled={!this.state.hasCompanyPermission}
                        >
                            Edit this company
                        </button>
                        <button
                            id="EditCompany"
                            className="btn secondary"
                            onClick={() =>
                                Navigator.navigateTo(Urls.get().CompanyViewFirmDetail, {
                                    scrollAfterNavigating: true,
                                    queryParamsObject: { id: this.state.selectFirm.CompanyCode },
                                })
                            }
                        >
                            View this company
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    private onClickCreate() {
        const { firmType } = this.state;
        //TODO: REMOVE TYPE QUERY PARAMS
        CompanyWizardAction.firmCreate(firmType, null, (data) => {
            Navigator.navigateTo(Urls.get().FirmDetail, {
                scrollAfterNavigating: true,
                queryParamsObject: { id: data.Id, type: firmType },
            });
        });
    }

    private onClickEdit() {
        const FirmType = this.state.selectFirm.FirmType;
        const CompanyId = this.state.selectFirm.HierarchyId;
        //TODO: REMOVE TYPE QUERY PARAMS
        CompanyWizardAction.firmCreate(FirmType, CompanyId, (data) => {
            Navigator.navigateTo(Urls.get().FirmDetail, {
                scrollAfterNavigating: true,
                queryParamsObject: { id: data.Id, type: FirmType },
            });
        });
    }

    private renderSetup(): JSX.Element {
        const { firmType, createType } = this.state;
        const options =
            createType == "Adviser"
                ? [FirmType.AppointedRepresentative, FirmType.DirectlyAuthorised]
                : [FirmType.Bond, FirmType.Pension];
        return (
            <>
                <div className="row">
                    <div className="col-12 col-sm-4">
                        <SelectEditor
                            // options={["Adviser", "ThridParty"]} //switch, turn off for now as third party is not required at the moment.
                            options={["Adviser"]}
                            getText={(v) => {
                                return v == "Adviser" ? "Adviser firm" : "Third party";
                            }}
                            label="Create a new firm"
                            selected={createType}
                            onChange={(v) => {
                                this.setState({
                                    createType: v,
                                    firmType: v == "Adviser" ? FirmType.AppointedRepresentative : FirmType.Bond,
                                });
                            }}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 col-sm-4">
                        <SelectEditor
                            options={options}
                            getText={(v) => {
                                return FirmTypeMap[v];
                            }}
                            placeholder="Please select"
                            label="Firm type"
                            selected={firmType}
                            required={"Please select Firm Type"}
                            onChange={(v) => {
                                this.setState({ firmType: v });
                            }}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 col-sm-4">
                        <button
                            className="btn secondary"
                            disabled={!this.state.firmType || !this.state.hasCompanyPermission}
                            onClick={() => this.state.hasCompanyPermission && this.onClickCreate()}
                        >
                            Create new company
                        </button>
                    </div>
                </div>
            </>
        );
    }

    private handleSort() {
        this.setState(
            (prevState) => ({
                OrderBy: CompanyDetailSort.CompanyId,
                SortDescending: prevState.OrderBy == CompanyDetailSort.DateCreated ? false : !prevState.SortDescending,
            }),
            () => this.getData(1)
        );
    }

    private renderTable(): JSX.Element {
        const { tableData, currentPage, isLoading } = this.state;
        if (!tableData) {return null;}
        return (
            <Table
                isLoading={isLoading}
                data={tableData.PageOfResults}
                showEmptyMsg={true}
                col={[
                    {
                        title: "Firm ID",
                        key: "CompanyCode",
                        sorter: () => this.handleSort(),
                        render: (data, row) => (
                            <div
                                onClick={() => this.setState({ selectFirm: row })}
                                style={{ textDecoration: "underline", cursor: "pointer" }}
                            >
                                {data}
                            </div>
                        ),
                    },
                    {
                        title: "Firm name",
                        key: "CompanyName",
                    },
                    {
                        title: "FirmType",
                        key: "FirmType",
                        render: (data) => <span>{FirmTypeMap[data]}</span>,
                    },
                    {
                        title: "FCA/trading reference",
                        key: "FSAAuthorisationNumber",
                    },
                    {
                        title: "FCA/trading status",
                        key: "FSAAuthorisationStatus",
                        render: (data) => <span>{FsaAuthorisationStatusMap[data]}</span>,
                    },
                    {
                        title: "Linked network",
                        key: "NetworkName",
                    },
                    {
                        title: "Postcode",
                        key: "Postcode",
                    },
                ]}
                needPagination={{
                    totalNumOfResult: tableData.TotalNumberOfResults,
                    onPaginationChange: (pageIndex) => this.handlePageChange(pageIndex),
                    currentPage: currentPage,
                }}
            />
        );
    }

    private renderFilter(): JSX.Element {
        const { filter } = this.state;
        const isWrapProviderSuperUser =
            UserStore.getUserInfo().IsWrapProviderSuperUser != null
                ? UserStore.getUserInfo().IsWrapProviderSuperUser
                : false;
        return (
            <>
                <CompanyWizardFilter
                    firmID={filter.firmID}
                    processType={filter.processType}
                    firmType={filter.firmType}
                    firmName={filter.firmName}
                    reference={filter.reference}
                    postcode={filter.postcode}
                    createdBy={filter.createdBy}
                    dateStartedFrom={filter.dateStartedFrom}
                    dateStartedTo={filter.dateStartedTo}
                    lastUpdatedFrom={filter.lastUpdatedFrom}
                    lastUpdatedTo={filter.lastUpdatedTo}
                    isSetup={true}
                    handleFilterChange={this.handleFilterChange}
                    onSearch={this.onSearch}
                    displayNetworkSearch={isWrapProviderSuperUser}
                />
            </>
        );
    }

    handleFilterChange = (changes: Dictionary[]) => {
        const updatedfilter = this.state.filter;
        for (const key in changes) {
            updatedfilter[key] = changes[key];
        }
        this.setState({ filter: updatedfilter });
    };

    handlePageChange = (pageIndex: number) => {
        this.setState({ currentPage: pageIndex });
        this.getData(pageIndex);
    };

    private onCompanyStoreChange() {
        const data = CompanyStore.getData();
        this.setState({ tableData: data, isLoading: false });
    }

    onSearch = () => {
        this.setState(
            { selectFirm: null, SortDescending: true, OrderBy: CompanyDetailSort.DateCreated, currentPage: 1 },
            () => this.getData(1)
        );
    };

    private getData(pageIndex: number): void {
        const query = this.getQuery(pageIndex);
        this.setState({ isLoading: true });
        CompanyWizardAction.getFirm(query);
    }

    private getQuery(pageIndex: number) {
        const { filter, pageSize } = this.state;
        const start = (pageIndex - 1) * pageSize + 1;
        const count = pageSize;
        const query = {
            CompanyId: filter.firmID,
            FirmType: filter.firmType,
            CompanyName: filter.firmName,
            Network: filter.network,
            FSAAuthorisationNumber: filter.reference,
            Postcode: filter.postcode,
            Start: start,
            Count: count,
            SortDescending: this.state.SortDescending,
            OrderBy: this.state.OrderBy,
            IncludeInactive: true,
        };
        return query;
    }
}
